import apiClient from '../api';

// Base API path
const API_PATH = '/drop-lot-locations';

// Get all drop lot locations
export const getAllDropLotLocations = (params = {}) => {
    return apiClient.get(API_PATH, { params });
};

// Get drop lot locations for a specific customer
export const getCustomerDropLotLocations = (customerId) => {
    return apiClient.get(`${API_PATH}/customer/${customerId}`);
};

// Get a specific drop lot location
export const getDropLotLocation = (id) => {
    return apiClient.get(`${API_PATH}/${id}`);
};

// Get gate code for a drop lot location (secured)
export const getDropLotGateCode = (id) => {
    return apiClient.get(`${API_PATH}/${id}/gate-code`);
};

// Create a new drop lot location
export const createDropLotLocation = (data) => {
    return apiClient.post(API_PATH, data);
};

// Update a drop lot location
export const updateDropLotLocation = (id, data) => {
    return apiClient.put(`${API_PATH}/${id}`, data);
};

// Delete (deactivate) a drop lot location
export const deleteDropLotLocation = (id) => {
    return apiClient.delete(`${API_PATH}/${id}`);
};

// Search nearby drop lot locations
export const getNearbyDropLotLocations = (lat, lng, maxDistance = 50000, customer = null) => {
    const params = { lat, lng, maxDistance };
    if (customer) params.customer = customer;
    return apiClient.get(`${API_PATH}/search/nearby`, { params });
};

// Get access log for a drop lot location
export const getDropLotAccessLog = (id, page = 1, limit = 50) => {
    return apiClient.get(`${API_PATH}/${id}/access-log`, { 
        params: { page, limit } 
    });
};

// Search drop lot locations
export const searchDropLotLocations = (searchTerm, customer = null, includeInactive = false) => {
    const params = { search: searchTerm };
    if (customer) params.customer = customer;
    if (includeInactive) params.includeInactive = includeInactive;
    return apiClient.get(API_PATH, { params });
};

export default {
    getAllDropLotLocations,
    getCustomerDropLotLocations,
    getDropLotLocation,
    getDropLotGateCode,
    createDropLotLocation,
    updateDropLotLocation,
    deleteDropLotLocation,
    getNearbyDropLotLocations,
    getDropLotAccessLog,
    searchDropLotLocations
}; 